<template>
    <div class="home">

        <pageheader text="Blokker fra spill"/>

        <p>
            Du kan selv bestemme om du ønsker å utestenge deg fra spill på vår nettside.
            Bekreft at du ønsker å sperre deg selv ute for ett år og trykk Blokker
        </p>

        <hr>

        <div v-if="blockStatus === false">
            <p>
                Noe gikk feil under blokkeringen.
            </p>
        </div>
        <div v-else-if="blockStatus !== null">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Laster...</strong>
        </div>
        <b-form v-else @submit="onSubmit">

            <b-form-group>
                <b-form-checkbox
                v-model="form.checked"
                name="checked"
                value="true"
                unchecked-value="false"
                size="md"
                >
                    Jeg bekrefter at jeg vil sperre meg fra spill
                </b-form-checkbox>
            </b-form-group>

            <hr v-if="errors.length">

            <b-alert show variant="danger" v-if="errors.length" class="errors">

                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>


            </b-alert>

            <br>

            <loading-button :disabled="formDisabled" >
                Bekreft med BankID
            </loading-button>
        </b-form>
    </div>
</template>

<script>
// @ is an alias to /src
import LoadingButton from '@/components/LoadingButton.vue';

export default {
    name: 'home',
    components: {
        LoadingButton
    },
    data() {
        return {
            blockStatus: null,
            form: {
                checked: false
            },
            errors:[],
            formDisabled: false
        }
    },
    mounted() {

        // Fetch params from query string and show success if done with bankid
        let query = this.$route.query;
        let key = query.state;

        // BankID error
        if (query.error) {
            this.$api.patch(`/users/${this.$store.getUser().card_id}/block/${key}/`, {
                error: query.error
            })
            this.blockStatus = false;
        }

        // BankID success
        else if ( query.state && query.session_state ) {
            let session_state = query.session_state;
            let code = query.code;

            this.blockStatus = true;

            this.$api.patch(`/users/${this.$store.getUser().card_id}/block/${key}/`, {
                session_state: session_state,
                code: code
            }).then((response) => {

                // Logout user
                this.$store.clear()
                this.$router.replace({ name: "login" });


            }).catch((error) => {
                this.blockStatus = false;
            });
        }


    },
    methods: {

        onSubmit(e) {
            e.preventDefault()

            this.errors = []
            if (!this.form.checked) this.errors.push('Du må akseptere.')
            if (this.errors.length) return;

            this.formDisabled = true;

            this.$api.post(`/users/${this.$store.getUser().card_id}/block/`, {})
            .then((response) => {
                // Send user to BankID window
                window.location = response.data.redirect_url;

            })
            .catch((error) => {
                this.errors.push('Kunne ikke igangsette blokkering.')

                this.formDisabled = false
            });
        },
        blockUser() {
            var data = {
                "blocked": true,
            };

            this.$api.patch(`/users/${this.$store.getUser().card_id}/`, data)
            .then((response) => {
                // Logout user
                this.$store.clear()
                this.$router.replace({ name: "login" });
            })
            .catch((response) => {
                this.errors.push("Kunne ikke blokker bruker");
            });
        }
    }
}
</script>
